var styles = {"footerItem":"SupportFooter-module_footerItem__23XLj","button":"SupportFooter-module_button__2Ehd4","loginButton":"SupportFooter-module_loginButton__3H_S0","modal":"SupportFooter-module_modal__1XNds"};

export { styles as default };
//# sourceMappingURL=SupportFooter.module.css.js.map
